export default "__VITE_ASSET__w6DT1KbV__"